var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper member-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {}, [_c('div', {
    staticClass: "claim-wrap"
  }, [_c('div', {
    staticClass: "claim-contents"
  }, [_c('div', {
    staticClass: "claim-title"
  }, [_c('h1', [_vm._v("Claim List ")]), _c('button', {
    staticClass: "clear-search",
    on: {
      "click": _vm.clearData
    }
  }, [_vm._v("Clear Search")])]), _c('claim-filter', {
    attrs: {
      "filters": _vm.filterQuery
    },
    on: {
      "onSearch": _vm.filterData
    }
  }), _c('div', {
    staticClass: "claim-btn-wrap"
  }, [_c('button', {
    staticClass: " upload-file-btn",
    on: {
      "click": _vm.openForm
    }
  }, [_c('i', {
    staticClass: "fas fa-upload"
  }), _c('span', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Upload claim file(s)")])])]), _c('div', {
    staticClass: "claim-list-tbl mt-3 table-responsive"
  }, [_c('div', {
    staticClass: "top-pagination"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.claimList,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.claimList = $event;
      }
    }
  })], 1), _c('claim-list-table', {
    attrs: {
      "claimList": _vm.claimList,
      "formatDate": _vm.formatDate,
      "statusClass": _vm.statusClass
    },
    on: {
      "view-file": _vm.viewFile,
      "submit-file": _vm.openSubmitModal
    }
  }), _c('pagination', {
    attrs: {
      "rows": _vm.claimList,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.claimList = $event;
      }
    }
  })], 1), _vm.selectedFiles ? _c('file-submit-modal', {
    attrs: {
      "files": _vm.selectedFiles,
      "claimData": _vm.claimData
    },
    on: {
      "close": function close($event) {
        _vm.selectedFiles = null;
      }
    }
  }) : _vm._e(), _c('file-upload-modal', {
    attrs: {
      "isEdit": _vm.isEdit,
      "row": _vm.selectedClaim
    },
    on: {
      "close": function close($event) {
        _vm.selectedClaim = null;
      },
      "update-isEdit": function updateIsEdit($event) {
        _vm.isEdit = $event;
      }
    }
  })], 1)])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }